import React, { useEffect, useState } from "react";
import * as Masks from "../../helpers/masks";
import Icon from "../Icon";



export const Input = ({label, error, placeholder, type, change, value, disabled, left, right, mask, action, autoComplete, inputRef, style, floating = true}) => {
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if(value && mask && typeof change === 'function'){
            change(applyMask(value));
        }
    }, [])
    const applyMask = value => {
        if(mask){
            return Masks[mask](value);
        }

        return value;
    }

    const onKeyUp = event => {
        if (event.charCode === 13) {
            if(action !== undefined){
                action();
            }
        }
    }

    const onKeyDown = event => {
        if (event.key === 'Backspace' && mask) {
            event.preventDefault();
            const digits = (value ?? '').toString().replace(/\D/g, '');
            const newDigits = digits.slice(0, -1);
            change(applyMask(newDigits || '0'));
        }
    }

    const togglePassword = () => setShowPassword(!showPassword);

    const inputType = type === 'password' && showPassword ? 'text' : type;

    const isFloating = Boolean(label) && floating;
    // No modo floating o próprio label vira o placeholder; usamos um placeholder
    // "vazio" (espaço) só para o CSS conseguir detectar o campo vazio via :placeholder-shown.
    const inputPlaceholder = isFloating ? ' ' : (placeholder ?? '');

    return (
        <div className={`input-group${left ? ' left' : ''}${error ? ' has-error' : ''}${isFloating ? ' floating' : ''}`} style={style}>
            {left &&
                <div className="left">
                    {left}
                </div>
            }
            {right &&
                <div className="right">
                    {right}
                </div>
            }
            <input
                ref={inputRef}
                type={inputType ?? 'text'}
                disabled={disabled ? true : false}
                placeholder={inputPlaceholder}
                onChange={e => change( applyMask(e.target.value))}
                value={value ?? ''}
                onKeyPress={onKeyUp}
                onKeyDown={onKeyDown}
                onFocus={mask ? (e => e.target.select()) : undefined}
                autoComplete={autoComplete ?? 'off'}
                style={{ paddingRight: type === 'password' ? '40px' : undefined }}
            />
            {label &&
                <label>{label}</label>
            }
            {type === 'password' && (
                    <span
                        onClick={togglePassword}
                        style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            color: '#888',
                            marginTop: '3px'
                        }}
                    >
                        {showPassword ? <Icon name="eyeoff" size={20} color="#7A7499" /> : <Icon name="eye" size={20} color="#7A7499" />}
                    </span>
                )}
            {error &&
                <span className="error-message">{error}</span>
            }
        </div>
    );
}

export default Input;